<div class="flex flex-col h-full">
	<ui-content-header
		type="page"
		title="{{ viewModel_().template?.metadata.templateName }}"
	>
		<ui-button
			title-action-left
			label="Back"
			icon="arrow-back"
			preset="EXTRA_LOW_EMPHASIS"
			(click)="goBack()"
		></ui-button>
		<ui-button actions label="Save" (click)="saveTemplate()"></ui-button>
	</ui-content-header>

	<div class="flex-1 grid grid-cols-12 gap-4">
		<div class="col-span-4">
			<ui-section title="Email Details" class="h-full" [scrollable]="true">
				<div section-content>
					<div class="flex flex-col gap-6">
						<div class="flex flex-col gap-2">
							<label for="templateName" class="p-sm">Template Name</label>
							<input
								id="templateName"
								name="templateName"
								[(ngModel)]="templateName_"
								placeholder="Enter template name"
								class="p-sm px-3 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
							/>
						</div>
						<div class="flex flex-col gap-2">
							<ui-select
								label="File Type"
								[options]="FILE_TYPE_OPTIONS"
								[(ngModel)]="fileType_"
								name="fileType"
							></ui-select>
						</div>
						<div class="flex flex-col gap-2">
							<ui-checkbox
								label="Set as default for file type"
								[(ngModel)]="default_"
								name="default"
							></ui-checkbox>
						</div>
						<ui-section
							type="sub-section"
							title="Email Recipient"
							class="border-t border-gray-200 pt-4"
						>
							<div section-content class="flex flex-col gap-2">
								<ui-select
									label="Type"
									[options]="EMAIL_RECIPIENT_TYPE_OPTIONS"
									[(ngModel)]="emailRecipientType_"
									name="emailRecipientType"
								></ui-select>
								<ui-select
									label="Subtype"
									[options]="emailRecipientSubTypeOptions_()"
									[disabled]="!emailRecipientSubTypeOptions_()"
									[(ngModel)]="emailRecipientSubType_"
									name="emailRecipientSubType"
								></ui-select>
							</div>
						</ui-section>
					</div>
				</div>
			</ui-section>
		</div>

		<div class="col-span-8">
			<ui-section
				title="Draft Email Template"
				class="h-full"
				[scrollable]="true"
			>
				@if (
					viewModel_().template?.metadata.source === 'global' &&
					viewModel_().canEdit
				) {
					<div
						actions
						class="px-4 py-2 p-sm rounded-xl bg-green-50 text-green-700 border border-green-200"
					>
						Closer Template
					</div>
				}
				<ng-container section-content>
					<form class="flex flex-col h-full gap-4">
						<div class="flex flex-col gap-2 flex-shrink-0">
							<label class="p-sm">Subject Line</label>
							<input
								placeholder="Enter subject"
								class="p-sm px-3 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
								[(ngModel)]="subject_"
								name="subject"
							/>
						</div>
						<div class="flex flex-col gap-2 flex-grow min-h-0">
							<label class="p-sm flex-shrink-0">Body</label>
							<app-email-template-editor
								class="flex-grow min-h-0"
								[(content)]="htmlMessage_"
								[tagOptions]="viewModel_().tagOptions"
							></app-email-template-editor>
						</div>
					</form>
				</ng-container>
			</ui-section>
		</div>
	</div>
</div>
